import React from "react";
import { IconButton, useTheme } from "@mui/material";
import { LuCheck } from "react-icons/lu";

export const CustomCheckbox = ({ checked, onChange }) => {
  return (
    <IconButton
      onClick={onChange}
      sx={{
        width: "20px",
        height: "20px",
        padding: "0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "2px solid",
        borderColor: checked ? "transparent" : "black",
        borderRadius: "4px",
        backgroundColor: checked ? "#FFD700" : "transparent",
        "&:hover": {
          backgroundColor: checked ? "#FFD700" : "rgba(0, 0, 0, 0.04)",
        },
        mt: 0.5,
      }}
    >
      {checked && <LuCheck color="black" size={24} />}
    </IconButton>
  );
};

export const CustomCheckbox2 = ({ checked, onChange, name, value }) => {
  const theme = useTheme();

  const handleClick = (event) => {
    // Create a synthetic event object that mimics a checkbox change
    const syntheticEvent = {
      target: {
        name,
        checked: !checked,
        value: value || name,
      },
    };

    onChange(syntheticEvent);
  };

  return (
    <IconButton
      onClick={handleClick}
      sx={{
        width: "18px",
        height: "18px",
        padding: "0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "2px solid",
        borderColor: checked ? "transparent" : theme.palette.secondary.main,
        borderRadius: "4px",
        backgroundColor: checked ? "#FFD700" : "transparent",
        "&:hover": {
          backgroundColor: checked ? "#FFD700" : "rgba(0, 0, 0, 0.04)",
        },
        mt: 0.5,
      }}
    >
      {checked && <LuCheck color="black" size={24} />}
    </IconButton>
  );
};
